// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__jJe4J","DesktopOnly":"Toolbar_DesktopOnly__SmxOj"};